import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { createProduct } from 'services/api/requests/requests';
export const useCreateProduct = body => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();
	return useMutation(() => createProduct(body), {
		onSuccess: sucess => {
			queryClient.invalidateQueries(['produto-list']);

			history.goBack();

			toast({
				title: 'Criado com sucesso!',
				description: 'Produto criado com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			error?.response?.data?.forEach((element: any) => {
				if (element.path !== 'empresa_id') {
					toast({
						title: 'Erro ao criar produto!',
						description: element.message,
						position: 'bottom-left',
						status: 'error',
						duration: 8000,
						isClosable: true,
					});
				}
			});
		},
	});
};
